module.exports = __webpack_public_path__ + "img/logo.a3d80e70.png";